export default {
      id: "vide-event_distracted-usage",
      viewBox: "0 0 22 35",
      url: __webpack_public_path__ + "img/icons.svg#vide-event_distracted",
      toString: function () {
        return this.url;
      }
    }